/**
 * API client for Centre Operations → Reports.
 *
 * Backend: oh_operations/centre_ops_report/alfred, one segment per call
 * (checklist | interactions | parent) so each part of the page can draw as its
 * numbers arrive. `apiEndpoints` is read INSIDE the function (TDZ-safety —
 * mirrors checklist.js).
 */
import { sentryLogger } from 'sentry'

import { apiEndpoints } from './common'

import { makeRequestUrl } from '../app/helpers'
import { get } from '../request'

const fetchCentreOpsReport = async ({ segment, from, to } = {}) => {
  try {
    const response = await get(
      makeRequestUrl(`${apiEndpoints.centreOpsReport}/alfred`, {
        segment,
        from,
        to
      })
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in fetching centre ops report')
    throw error
  }
}

export { fetchCentreOpsReport }
